<template>
  <v-card class="card-border mt-4">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="getDataTable" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip v-if="$ability.can('Executar','Procedures')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="executionProcedure(item.endpoint)"
              >
                <v-icon>mdi-play-outline</v-icon>
              </v-btn>
            </template>
            Executar
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import http from "@/services/http";
import Procedures from "@/services/procedures";
export default {
  name: "Procedures",

  data() {
    return {
      search: "",
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Endpoint", value: "endpoint" },
        { text: "Ações", value: "action", sortable: false, align: "center" }
      ],
      getDataTable: [],
      serviceProcedures: new Procedures()
    };
  },

  methods: {
    async executionProcedure(endpoint) {
      try {
        await http.post(endpoint);
      } catch (error) {
        this.$toast.error(error);
      }
    },

    async buscar() {
      try {
        const response = await this.serviceProcedures.getAll();
        this.getDataTable = response;
      } catch (error) {
        this.$toast.error(error);
      }
    }
  },

  created() {
    this.buscar();
  }
};
</script>

<style>
</style>